export const CHANGE_ACCOUNT_TYPE = 'containers/AccountTypeProvider/CHANGE_ACCOUNT_TYPE';
export const CHANGE_ACCOUNT_TYPE_SUCCESS = 'containers/AccountTypeProvider/CHANGE_ACCOUNT_TYPE_SUCCESS';

export const DOWNLOADER_ACCOUNT = 'downloader';
export const CREATOR_ACCOUNT = 'creator';
